// sessionStorage key holding the OAuth `state` issued for the in-flight SSO redirect.
export const SSO_STATE_STORAGE_KEY = 'ssoState';
